'use client'

import { useMemo } from 'react'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { type StoryblokRichTextNode } from '@storyblok/richtext'
import { Text } from 'ui/src/components/Text/Text'
import { type FontSizes } from 'ui/src/theme/typography'
import { renderRichTextToJsx } from '../RichTextBlock/richTextReactRenderer'
import { textBlockContainer } from './TextBlock.css'

type TextColor = 'textPrimary' | 'textSecondary' | 'textTertiary'

export type TextBlockProps = SbBaseBlockProps<{
  body: StoryblokRichTextNode
  balance?: boolean
  color?: TextColor
  fontSize?: FontSizes
  fontSizeDesktop?: FontSizes
  textAlignment?: 'left' | 'center' | 'right' | ''
}>

export const TextBlock = ({ blok }: TextBlockProps) => {
  const content = useMemo(() => renderRichTextToJsx(blok.body), [blok.body])
  const fontSizes = {
    _: blok.fontSize ?? 'md',
    ...(blok.fontSizeDesktop && { md: blok.fontSizeDesktop }),
  }

  return (
    <Text
      {...storyblokEditable(blok)}
      as="div"
      align={blok.textAlignment === '' ? undefined : blok.textAlignment}
      balance={blok.balance}
      className={textBlockContainer}
      color={blok.color}
      size={fontSizes}
      data-large-text={blok.fontSizeDesktop === 'xl'}
    >
      {content}
    </Text>
  )
}

TextBlock.blockName = 'text'
